import React, { createContext, useReducer } from 'react'
import PropTypes from 'prop-types'

const initialState = {
  valid: false
}

export const PASSWORD = {
  VALID: {
    SET: 'PASSWORD/ALL/SET'
  }
}

let reducer = ( state, action ) => {
  switch(action.type) {
    case "reset":
      return initialState
    case PASSWORD.VALID.SET:
      return { ...state, valid: action.payload }
    default:
      return state
  }
}

export const PasswordContext = createContext()

export const PasswordProvider = ({ children }) => {
  let [passwordState, passwordUpdate] = useReducer(reducer, initialState)
  let value = { passwordState, passwordUpdate }

  return (
    <PasswordContext.Provider value={ value }>
      { children }
    </PasswordContext.Provider>
  )
}

PasswordProvider.propTypes = {
  children: PropTypes.node
}

export const PasswordConsumer = PasswordContext.Consumer
